import React from 'react';
import { SlideInLeft, SlideInRight } from './Animations';

export default function About() {
  return (
    <section id="about" style={{
      background: '#fff',
      padding: 'clamp(60px, 8vw, 100px) clamp(20px, 4vw, 52px)',
    }}>
      <div style={{
        maxWidth: '1160px', margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '64px', alignItems: 'center',
      }}>
        <SlideInLeft>
          <div style={{ position: 'relative' }}>
            <div style={{
              position: 'absolute', top: '20px', left: '-20px',
              right: '20px', bottom: '-20px',
              background: 'linear-gradient(135deg, #1E8449, #27AE60)',
              borderRadius: '24px', zIndex: 0, opacity: 0.15,
            }} />
            <img
              src="/gracious.png"
              alt="Gracious"
              style={{
                width: '100%', height: '480px',
                borderRadius: '24px',
                position: 'relative', zIndex: 1,
                objectFit: 'cover', objectPosition: 'center top',
                border: '1px solid #F0F0F0',
                boxShadow: '0 8px 32px rgba(30,132,73,0.15)',
                display: 'block',
              }}
            />
          </div>
        </SlideInLeft>

        <SlideInRight>
          <div>
            <span style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '11px', fontWeight: 600, letterSpacing: '4px',
              textTransform: 'uppercase', color: '#C9973A',
              marginBottom: '12px', display: 'block',
            }}>About Gracious</span>
            <div style={{
              width: '48px', height: '3px',
              background: 'linear-gradient(90deg, #1E8449, #27AE60)',
              marginBottom: '20px', borderRadius: '999px',
            }} />
            <h2 style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(28px, 4vw, 44px)', fontWeight: 700,
              lineHeight: 1.15, marginBottom: '20px', color: '#111827',
            }}>
              Entrepreneur. Mentor.<br />
              <em style={{ fontStyle: 'italic', color: '#1E8449' }}>Life Builder.</em>
            </h2>
            <p style={{
              fontSize: '15px', lineHeight: 1.85,
              color: '#6B7280', marginBottom: '16px',
            }}>
              I am Gracious — a passionate entrepreneur, wellness advocate, and network marketing coach who believes every woman has the power to build the life she deserves. My journey spans herbal wellness, real estate, digital marketing, and coaching.
            </p>
            <p style={{
              fontSize: '15px', lineHeight: 1.85,
              color: '#6B7280', marginBottom: '32px',
            }}>
              Whether you are looking to improve your health, grow your income, or build a business from scratch — you are in the right place. Let us build something great together.
            </p>

            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              {[
                { href: 'https://wa.me/2347069495976', label: 'WhatsApp', bg: '#25D366', color: '#fff' },
                { href: '#', label: 'Instagram', bg: '#fff', color: '#1E8449' },
                { href: '#', label: 'Facebook', bg: '#fff', color: '#1E8449' },
              { href: 'https://tiktok.com/@kentoto21', label: 'TikTok', bg: '#000', color: '#fff' },
              ].map(({ href, label, bg, color }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '12px', fontWeight: 600, letterSpacing: '1px',
                  textTransform: 'uppercase', textDecoration: 'none',
                  padding: '12px 24px',
                  border: '1.5px solid #E5E7EB',
                  background: bg, color: color,
                  borderRadius: '999px',
                  transition: 'all 0.25s',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                >{label}</a>
              ))}
            </div>
          </div>
        </SlideInRight>
      </div>
    </section>
  );
}
